<template>
  <div v-if="userInfo" class="grid grid-cols-12 gap-6">
    <div class="col-span-12 xxl:col-span-9 grid grid-cols-12 gap-6">
      <!-- BEGIN: General Report -->
      <div class="col-span-12 mt-8 marginTop">
        <div class="q-grid intro-y">
          <div class="my-data">
            <div class="intro-y flex items-center h-10">
              <h2 class="text-lg font-medium truncate mr-5">我的资料</h2>
              <div class="refresh" style="cursor: pointer" @click="getRefresh">
                <a class="ml-auto flex text-theme-1">
                  <RefreshCcwIcon class="w-4 h-4 mr-3" /> 刷新数据
                </a>
              </div>
            </div>
            <div class="itemBox item-padding">
              <div class="q-FloatLeft1">
                <img
                  :src="
                    userInfo.avatar ||
                    'http://osssys.izhyin.cn/9_avatar.png?1610590122'
                  "
                  alt=""
                />
                <h3
                  v-if="userInfo.nickname"
                  class="q-FloatLeft1-h3"
                  style="margin: 5px 0; font-size: 1.1vw"
                >
                  {{ userInfo.nickname }}
                </h3>
                <h3
                  v-if="!userInfo.nickname"
                  style="margin: 5px 0; font-size: 16px; cursor: pointer"
                >
                  <router-link to="/Dashboard/profile">设置昵称</router-link>
                </h3>

                <div class="titleColor">{{ userInfo.discount.name }}</div>
              </div>

              <ul class="q-floatLeft2">
                <li class="green-item">
                  <span>微信绑定</span>
                  <span v-if="userInfo.acc_wx_id">{{
                    userInfo.acc_wx_id
                  }}</span>
                  <span v-else style="cursor: pointer"
                    ><router-link to="/Dashboard/profile" style="color: #1890ff"
                      >去绑定</router-link
                    ></span
                  >
                </li>
                <li class="red-item">
                  <span>身份认证</span>
                  <span v-if="userInfo.id_card">{{
                    userInfo.id_card | identitFilter
                  }}</span>
                  <span v-else style="cursor: pointer"
                    ><router-link to="/Dashboard/profile"
                      >去认证</router-link
                    ></span
                  >
                </li>
                <li class="red-item">
                  <span>验证⼿机</span>
                  <span v-if="userInfo.phone">{{
                    userInfo.phone | phoneFilter
                  }}</span>
                  <span v-else style="cursor: pointer; color: #1890ff"
                    >去绑定</span
                  >
                </li>
                <li class="red-item">
                  <span>密码设置</span>

                  <span style="cursor: pointer; color: #1890ff">修改密码</span>
                </li>
                <li class="bule-item">
                  <span>上次登录</span>
                  <span>{{ userInfo.login_time }}</span>
                </li>

                <li class="bule-item">
                  <span class="address" v-if="userInfo.address">{{
                    userInfo.address
                  }}</span>
                </li>
              </ul>

              <div class="circle-box">
                <el-progress
                  type="circle"
                  :percentage="25"
                  :width="135"
                  :stroke-width="12"
                ></el-progress>
                <h3>安全系数</h3>
              </div>
            </div>
          </div>
          <div class="all-itemBoxB">
            <div class="screenBody">
              <h2 class="screenBody-item text-lg font-medium truncate mr-5">
                我的余额
              </h2>
              <div class="itemBoxB">
                <div class="itemHader">
                  <img src="@/assets/images/money.png" alt="" />
                  <div class="div1">
                    <span>
                      <router-link to="/Dashboard/point-of-sale"
                        >充值</router-link
                      >
                    </span>
                    <i class="el-icon-arrow-right"></i>
                  </div>
                </div>

                <div class="itemContent">
                  {{
                    (userInfo.fin_invalid + userInfo.fin_valid) | formatMoney
                  }}
                </div>
                <div class="itemContent2">我的余额</div>

                <div
                  class="itemBottomA"
                  v-if="userInfo.fin_last_deposit_time >= 1"
                >
                  上次充值：{{ userInfo.fin_last_deposit_time | formatDate }}
                </div>
              </div>
            </div>
            <div class="screenBody">
              <h2 class="screenBody-item text-lg font-medium truncate mr-5">
                我的推广
              </h2>
              <div class="itemBoxB">
                <div class="itemHader">
                  <img src="@/assets/images/geren.png" alt="" />
                  <div class="div2">
                    <span>
                      <router-link to="/Dashboard/invitation"
                        >推广</router-link
                      ></span
                    >
                    <i class="el-icon-arrow-right"></i>
                  </div>
                </div>

                <div class="itemContent">{{ userInfo.invite_sum }}</div>
                <div class="itemContent2">我的推广</div>

                <div class="itemBottomB" v-if="userInfo.invite_last_time >= 1">
                  上次推广：{{ userInfo.invite_last_time | formatDate }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-span-12 mt-5">
          <div class="intro-y flex items-center h-10">
            <h2 class="text-lg font-medium truncate mr-5 mr-auto">我的财务</h2>
          </div>
        </div>

        <div class="intro-y box mt-5">
          <div class="p-5">
            <div class="flex flex-col sm:flex-row items-center">
              <div class="flex flex-wrap sm:flex-no-wrap mr-auto">
                <div>
                  <div class="shouru">
                    <div>￥{{ reportTotal.income }}</div>
                    <div
                      style="
                        color: #718096;
                        font-size: 14px;
                        text-align: center;
                      "
                    >
                      收入
                    </div>
                  </div>
                  <div class="zhichi">
                    <div>￥{{ reportTotal.expenditure }}</div>
                    <div style="color: #718096; font-size: 14px">支出</div>
                  </div>
                </div>
              </div>
              <!-- <div class="dropdown mt-3 sm:mt-0 mr-auto sm:mr-0">
                <button
                  class="dropdown-toggle button font-normal border text-white relative flex items-center text-gray-700"
                >
                  Filter by Month
                  <ChevronDownIcon class="w-4 h-4 ml-2" />
                </button>
                <div class="dropdown-box w-40">
                  <div
                    class="dropdown-box__content box p-2 overflow-y-auto h-32"
                  >
                    <a
                      class="flex items-center block p-2 transition duration-300 ease-in-out bg-white hover:bg-gray-200:bg-dark-2 rounded-md"
                      >Januar1y</a
                    >
                    <a
                      class="flex items-center block p-2 transition duration-300 ease-in-out bg-white hover:bg-gray-200:bg-dark-2 rounded-md"
                      >February2</a
                    >
                    <a
                      class="flex items-center block p-2 transition duration-300 ease-in-out bg-white hover:bg-gray-200:bg-dark-2 rounded-md"
                      >March</a
                    >
                    <a
                      class="flex items-center block p-2 transition duration-300 ease-in-out bg-white hover:bg-gray-200:bg-dark-2 rounded-md"
                      >June</a
                    >
                    <a
                      class="flex items-center block p-2 transition duration-300 ease-in-out bg-white hover:bg-gray-200:bg-dark-2 rounded-md"
                      >July</a
                    >
                  </div>
                </div>
              </div> -->
            </div>
            <div class="mt-8" v-if="reportArr">
              <ReportLineChart :height="290" :reportData="reportArr" />
            </div>
          </div>
        </div>

        <div class="col-span-12 mt-5">
          <div class="intro-y flex items-center h-10">
            <h2 class="text-lg font-medium truncate mr-5 mr-auto">我的应用</h2>
            <!-- <div class="dropdown mt-3 sm:mt-0 mr-auto sm:mr-0">时间选择器</div> -->
          </div>
        </div>
        <div class="CardView-box">
          <div v-if="CardData.length >= 1" class="CardView-box2">
            <CardView
              v-for="(item, index) in CardData"
              :key="index"
              :card-data="item"
            />
          </div>
          <div v-else class="CardView-kong">
            <img src="../assets/images/kong-app.png" alt="" />
          </div>
        </div>
      </div>

      <!-- END: Weekly Top Products -->
    </div>
    <div
      class="col-span-12 xxl:col-span-3 xxl:border-l border-theme-5 -mb-10 pb-10"
      style="z-index: 1"
    >
      <div class="xxl:pl-6 grid grid-cols-12 gap-6 intro-x">
        <!-- BEGIN: 我的专属客服经理 -->
        <div
          v-if="false"
          class="col-span-12 md:col-span-6 xl:col-span-4 xxl:col-span-12 mt-3 xxl:mt-8 intro-x"
        >
          <div class="intro-x flex items-center h-10">
            <h2 class="text-lg font-medium truncate mr-5">我的专属客服经理</h2>
          </div>
          <div class="mt-5">
            <div class="exclusive-box">
              <div class="manager-left">
                <div>
                  <img
                    :src="
                      userInfo.avatar ||
                      'http://osssys.izhyin.cn/9_avatar.png?1610590122'
                    "
                    alt=""
                  />
                </div>
                <div class="managerNmae">Robert De Niro</div>
                <div class="managerPhone">电话：1123451516125</div>
              </div>
              <!-- 二维码 -->
              <img
                class="rightCode"
                src="@/assets/images/profile-1.jpg"
                alt=""
              />
            </div>
          </div>
        </div>
        <!-- BEGIN: 我的好友 -->
        <div
          v-if="false"
          class="col-span-12 md:col-span-6 xl:col-span-4 xxl:col-span-12 mt-3 xxl:mt-8"
        >
          <div class="intro-x flex items-center h-10">
            <h2 class="text-lg font-medium truncate mr-5">我的好友</h2>
          </div>
          <div class="mt-5">
            <div
              v-for="(faker, fakerKey) in $_.take($f(), 5)"
              :key="fakerKey"
              class="intro-x"
            >
              <div class="box px-5 py-3 mb-3 flex items-center zoom-in">
                <div
                  class="w-10 h-10 flex-none image-fit rounded-full overflow-hidden"
                >
                  <img
                    alt=""
                    :src="require(`@/assets/images/${faker.photos[0]}`)"
                  />
                </div>
                <div class="ml-4 mr-auto">
                  <div class="font-medium">
                    {{ faker.users[0].name }}
                  </div>
                  <div class="text-gray-600 text-xs">
                    <span style="color: #718096">ID: 123</span>
                  </div>
                </div>
              </div>
            </div>
            <a
              class="intro-x w-full block text-center rounded-md py-3 border border-dotted border-theme-15 text-theme-16"
              >查看更多</a
            >
          </div>
        </div>
        <div
          class="haoyou-box col-span-12 md:col-span-6 xl:col-span-4 xxl:col-span-12 mt-3 xxl:mt-8"
        >
          <img src="../assets/images/kong-haoyou.png" alt="" />
          <div>暂无好友，快去邀请好友吧</div>
          <span>
            <router-link to="/Dashboard/invitation">前往邀请</router-link>
          </span>
        </div>
      </div>

      <div class="intro-x tongzhiHtml">
        <div class="flex items-center h-10">
          <h2 class="text-lg font-medium truncate mr-5">系统通知</h2>
        </div>
        <div v-if="false" class="tongzhi-box" style="overflow: hidden">
          <h1 style="color: #2d3748; font-size: 16px">
            Lorem ipsum is simply dummy text
          </h1>
          <p style="color: #a0aec0; font-size: 14px; line-height: 20px">
            20 Hours ago
          </p>
          <div class="contents">
            Lorem Ipsum is simply dummy text of the printing and typesetting
            industry. Lorem Ipsum has been the industry’s standard dummy text
            ever since the 1500s.
          </div>

          <div class="buttom-botton">
            <div style="background: #edf2f7; float: left; cursor: pointer">
              查看详情
            </div>
            <div
              style="
                background: ##edf2f7;
                float: right;
                border: 1px solid #edf2f7;
                cursor: pointer;
              "
            >
              Dismiss
            </div>
          </div>
        </div>

        <div v-else class="tongzhi-img">
          <img src="../assets/images/kong-tongzhi.png" alt="" />
        </div>
      </div>
    </div>

    <!-- <betaPop
      v-if="isBetaPop && isPop"
      @onBetaPop="onBetaPop"
      @touchmove.native.stop.prevent
    /> -->
  </div>
</template>

<script>
import ReportLineChart from "../components/ReportLineChart";
// import betaPop from "../modules/betaPop";
import CardView from "../modules/Crad";
import request from "../utils/request";

import Cookies from "js-cookie";
import { formatDate } from "../utils/time";



export default {
  components: {
    CardView,
    ReportLineChart,
    // betaPop,
  },

  filters: {
    // 手机号过滤保密
    phoneFilter: function (phone) {
      if (phone) {
        return (
          String(phone).substring(0, 3) +
          "****" +
          String(phone).substring(7, 13)
        );
      } else {
        return "未绑定";
      }
    },
    // 身份证过滤保密
    identitFilter: function (ic) {
      ic = String(ic);
      return "***************" + ic.substr(14);
    },
    formatDate: function (value) {
      return formatDate(value);
    },
  },

  data() {
    return {
      salesReportFilter: "",
      date: "",
      datePicker: "",
      CardData: [],
      isBetaPop: true,
      userInfo: null,
      reportTotal: {
        income: null,
        expenditure: null,
      },
      reportArr: null,

      // img: require("../assets/images/ios.png")
    };
  },
  computed: {
    isPop: function () {
      return this.$route.params.isPop;
    },
  },

  // activated() {
  //   console.log(Cookies.get("userInfo"))
  //   // if (Cookies.get("userInfo")) {
  //   //   console.log(Cookies.get("userInfo"), 'Cookies.get("userInfo")');

  //   //   this.userInfo = JSON.parse(Cookies.get("userInfo"));

  //     request({
  //       url: `/api/tool/ip/${this.userInfo.login_ip}`,
  //     }).then((xi) => {
  //       if (xi.data) this.userInfo.address = xi.data.addr;
  //     });
  //   // } else {
  //   //   this.userInfo = null;
  //   // }
  // },
  mounted() {
    this.getAppInit();
    this.reportInit();


  },

  created() {},
  methods: {
    initUser: function () {
      setTimeout(() => {
        if (Cookies.get("userInfo")) {
          this.userInfo = JSON.parse(Cookies.get("userInfo"));

          request({
            url: `/api/tool/ip/${this.userInfo.login_ip}`,
          }).then((xi) => {
            if (xi.data) this.userInfo.address = xi.data.addr;
          });

          return;
        } else {
          this.initUser();
        }
      }, 800);
    },

    reportInit: function () {
      request({
        url: "/api/myApp/report",
        method: "GET",
      }).then((res) => {
        console.log(res);

        res.data.total.expenditure = res.data.total.expenditure.toFixed(2);
        res.data.total.income = res.data.total.income.toFixed(2);
        this.reportTotal = res.data.total;
        this.reportArr = res.data.list;
      });
    },

    // 获取应用-我的列表
    getAppInit: function () {
      request({
        url: "/api/myApp/list",
      })
        .then((res) => {
          if (res.data.data.length >= 1) {
            this.CardData = res.data.data.sort((a, b) => {
              return a.expire > b.expire ? 1 : -1;
            });
          }

          if (Cookies.get("userInfo")) {
            this.userInfo = JSON.parse(Cookies.get("userInfo"));

            request({
              url: `/api/tool/ip/${this.userInfo.login_ip}`,
            }).then((xi) => {
              if (xi.data) this.userInfo.address = xi.data.addr;
            });
            return;
          } else {
            this.initUser();
          }
        })
        .catch((err) => {
          if (Cookies.get("userInfo")) {
            this.userInfo = JSON.parse(Cookies.get("userInfo"));

            request({
              url: `/api/tool/ip/${this.userInfo.login_ip}`,
            }).then((xi) => {
              if (xi.data) this.userInfo.address = xi.data.addr;
            });
            return;
          } else {
            this.initUser();
          }
        });
    },
    // 刷新数据
    getRefresh: function () {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      setTimeout(() => {
        this.getAppInit();
        loading.close();
      }, 400);
      // console.log('刷新')
    },
    onBetaPop: function (evnet) {
      this.isBetaPop = evnet;
    },

    prevImportantNotes() {
      this.$refs["important-notes"].prev();
    },
    nextImportantNotes() {
      this.$refs["important-notes"].next();
    },
  },
};
</script>

<style lang="scss" scoped>
.all-itemBoxB {
  float: left;
  width: 45%;
  box-sizing: border-box;
}
.screenBody {
  float: left;
  width: 45%;
  margin-left: 20px;
  box-sizing: border-box;
}
.itemBoxB {
  width: 100%;
  height: 246px;
  background: #fff;
  float: left;
  margin-top: 26px;
  border-radius: 22px;
  box-sizing: border-box;
  padding: 6.6%;
  overflow: hidden;
}
.itemBoxB:last-child {
  margin-left: 2.7%;
}

.item-padding {
  // padding: 36px 1.2%;
}

.q-grid {
  box-sizing: border-box;
  overflow: hidden;
  font-size: 0.85vw;
}
.my-data {
  float: left;
  width: 55%;
}
.itemBox {
  width: 100%;
  box-sizing: border-box;
  float: left;
  margin: 20px 2.5% 0 0;
  background: #fff;
  box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.03);
  border-radius: 22px;
  position: relative;
  white-space: nowrap;
  .q-FloatLeft1 {
    float: left;

    text-align: center;
    padding: 42px 0 42px 36px;
    .q-FloatLeft1-h3 {
      overflow: hidden;
      text-overflow: ellipsis;
      display: inline-block;
    }

    img {
      width: 90px;
      height: 90px;
      border-radius: 30px;
    }

    .titleColor {
      background: #fff0d6;
      border: #ffcc54 1px solid;
      width: 87px;
      height: 28px;
      border-radius: 0.5vw;
      font-size: 1rem;
      font-weight: 400;
      line-height: 25px;
      margin-left: 4px;
      color: #ffcc54;
      opacity: 1;
    }
  }
}

.q-floatLeft2 {
  display: inline-block;
  line-height: 2.2;
  margin-left: 4%;
  padding: 20px 0;
}
.q-floatLeft2 li {
  position: relative;
}

.q-floatLeft2 > li > span:nth-child(1) {
  margin-left: 30px;
}

.q-floatLeft2 > li > span:nth-child(2) {
  color: #4a5568;
  font-size: 14px;
  margin-left: 20px;
}

.address {
  color: #ff3151;
  font-size: 14px;
  display: inline-block;
}

.green-item::before {
  content: "";
  width: 16px;
  height: 16px;
  background: #5af462;
  border-radius: 50%;
  position: absolute;
  left: 0;
  top: 8px;
}
.red-item::before {
  content: "";
  width: 16px;
  height: 16px;
  background: red;
  border-radius: 50%;
  position: absolute;
  left: 0;
  top: 8px;
}

.bule-item::before {
  content: "";
  width: 16px;
  height: 16px;
  background: #1890ff;
  border-radius: 50%;
  position: absolute;
  left: 0;
  top: 8px;
}

.circle-box {
  text-align: center;
  font-weight: bold;
  color: #718096;
  position: absolute;
  right: 20px;
  top: 40px;
}

.itemHader {
  padding-bottom: 10px;
  overflow: hidden;
  img {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    float: left;
  }
  .div1 {
    float: right;
    width: 50px;
    height: 24px;
    background: #ffe2e4;
    opacity: 1;
    border-radius: 12px;
    color: #ff4242;
    font-size: 12px;
    text-align: center;
    line-height: 2.2;
  }
  .div2 {
    float: right;
    width: 50px;
    height: 24px;
    background: #daf0ff;
    opacity: 1;
    border-radius: 12px;
    color: #1890ff;
    font-size: 12px;
    text-align: center;
    line-height: 2.2;
  }
}

.itemContent {
  font-size: 30px;
  color: #2d3748;
  font-weight: bold;

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.itemContent2 {
  color: #718096;
  font-size: 16px;
}

.itemBottomA::before {
  position: absolute;
  content: "";
  width: 8px;
  height: 8px;
  left: 0px;
  top: 6px;
  border-radius: 50%;
  background: #ff4141;
}

.itemBottomB::before {
  position: absolute;
  content: "";
  width: 8px;
  height: 8px;
  left: 0px;
  top: 6px;
  border-radius: 50%;
  background: #1890ff;
}

.itemBottomB {
  font-size: 14px;
  color: #4a5568;
  width: 100%;
  margin-top: 80px;
  text-indent: 20px;
  position: relative;
}

.itemBottomA {
  font-size: 14px;
  color: #4a5568;
  width: 100%;
  margin-top: 80px;
  text-indent: 20px;
  position: relative;
}

.shouru {
  float: left;
  width: 120px;

  box-sizing: border-box;
  font-size: 20px;
  color: #2449af;
  border-right: 3px dashed #e2e8f0;
  text-align: center;
  padding-right: 20px;
}
.zhichi {
  float: left;
  width: 120px;
  text-align: center;
  box-sizing: border-box;
  font-size: 20px;
  color: #718096;
  padding-left: 20px;
}
.exclusive-box {
  width: 100%;
  height: 115px;
  background: #ffffff;
  box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.03);
  opacity: 1;
  border-radius: 22px;
  box-sizing: border-box;
}

.CardView-box {
  width: calc(100% + 25px);
  overflow: hidden;
  margin-top: 20px;
}

.CardView-box2 {
  width: calc(100% + 25px);
}

.exclusive-box {
  padding: 12px 20px;
  overflow: hidden;
}

.manager-left {
  float: left;
  margin-right: auto;

  img {
    width: 42px;
    height: 42px;
    border-radius: 50%;
    overflow: hidden;
  }

  .managerNmae {
    font-size: 14px;
    font-weight: 400;
    line-height: 19px;
    color: #080e18;
    opacity: 1;
    margin: 6px 0;
  }
  .managerPhone {
    font-size: 12px;
    font-weight: 300;
    line-height: 16px;
    color: #718096;
    opacity: 1;
  }
}

.rightCode {
  width: 91px;
  height: 91px;
  float: right;
}

.tongzhiHtml {
  padding: 20px 0 20px 20px;
  margin-top: 20px;
  .tongzhi-box {
    width: 353px;
    height: 228px;
    background: #ffffff;
    box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.03);
    opacity: 1;
    border-radius: 22px;
    margin-top: 20px;
    padding: 20px;
    .buttom-botton {
      width: 100%;
      overflow: hidden;
      margin-top: 20px;
      div {
        color: #718096;
        font-size: 14px;
        width: 68px;
        height: 31px;
        border-radius: 7px;
        text-align: center;
        line-height: 31px;
      }
    }
  }
}
.tongzhi-img {
  max-width: 353px;
  height: 433px;
  background: #ffffff;
  box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.03);
  opacity: 1;
  border-radius: 22px;
  line-height: 433px;
  text-align: center;
  img {
    display: inline-block;
  }
}

.haoyou-box {
  max-width: 353px;
  height: 433px;
  background: #ffffff;
  box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.03);
  opacity: 1;
  border-radius: 22px;
  text-align: center;
  img {
    margin: 80px 0 30px;
    display: inline-block;
  }
  div {
    color: #999999;
    font-size: 16px;
  }
  span {
    width: 110px;
    height: 37px;
    background: #1890ff;
    opacity: 1;
    border-radius: 12px;
    color: #fff;
    font-size: 14px;
    text-align: center;
    line-height: 37px;
    margin-top: 30px;
    display: inline-block;
    cursor: pointer;
  }
}

.screenBody-item {
  height: 40px;
  line-height: 40px;
}

@media screen and (max-width: 1172px) {
  .CardView-box {
    width: 100%;
  }
  .all-itemBoxB {
    width: 100% !important;
  }
  .screenBody {
    width: 100% !important;
    margin-left: 0px !important;
  }
  .my-data {
    width: 100% !important;
  }
  .itemBox {
    width: 100%;
    min-width: 420px;
  }
  .itemBoxB {
    width: 100%;
    margin-left: 0 !important;
    padding: 24px;
    margin-top: 3% !important;
  }
}

@media screen and (max-width: 618px) {
  .circle-box {
    display: none;
  }

  .itemBox,
  .itemBoxB {
    border-radius: 0;
  }
}

@media screen and (max-width: 600px) {
  .all-itemBoxB {
    width: 100% !important;
  }
  .screenBody {
    width: 100% !important;
    margin-left: 0px !important;
  }
  .itemBoxB {
    border-radius: 10px !important;
    padding: 15px !important;
  }
  .itemBox {
    border-radius: 10px !important;
    min-width: auto !important;
    max-height: 420px !important;
    margin-top: 0 !important;
    .q-FloatLeft1 {
      // margin: 0 auto 20px !important;
    }
  }
  .text-theme-1 {
    min-width: 130px !important;
    // float: right;
    // margin-top: 5px;
  }
  .marginTop {
    margin-top: 0 !important;
    float: right !important;
  }
}


@media screen and (max-width: 415px) {
  .q-FloatLeft1 {
    display: none;
  }
}

.CardView-kong {
  width: 1170px;
  height: 400px;
  background: #ffffff;
  line-height: 400px;
  text-align: center;
  box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.03);
  opacity: 1;
  border-radius: 22px;
  img {
    display: inline-block;
  }
}
</style>
